import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import * as appConfig from '../../app.config';

import { Textbox } from '../../models/editors/textbox.model';
import { Hidden } from '../../models/editors/hidden.model';

import { ApiService } from '../../shared/services/api.service';
import { FormControlService } from '../../shared/services/form-control.service';
import { AlertService } from '../../shared/services/alert.service';
import { FormDetailBase } from '../../shared/components/base/form-detail/form-detail.base.component';
import { MenuItem } from '../../models/menu/menu.model';
import { MenuService } from './services/menu.service';

@Component({
  selector: 'swb-menu-detail',
  templateUrl:
    './../../shared/components/base/form-detail/form-detail.modal.base.component.html',
  providers: [FormControlService]
})
export class CustomMenuItemDetailComponent extends FormDetailBase<MenuItem>
  implements OnInit {
  protected _headerTitle = 'Přidat položku menu';

  public url = 'custom-menu-items';
  protected _redirect = './menu';

  protected _fieldsConfig: Array<any> = [
    new Textbox({
      key: 'title',
      label: 'Název odkazu',
      validators: [Validators.required]
    }),
    new Textbox({
      key: 'url',
      label: 'Adresa odkazu',
      validators: [Validators.required]
    })
  ];

  public lang = appConfig.languages[0];

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _menuService: MenuService
  ) {
    super(_formService, _apiService, _router, _alertService);
  }

  ngOnInit() {
    this._saveCallback = (event: any) => {
      this._menuService.reload(event.data);
    };
    if (typeof this._route.snapshot.params['lang'] !== 'undefined') {
      this.lang = this._route.snapshot.params['lang'];
      this.fieldsConfig.push(
        new Hidden({
          key: 'lang',
          value: this.lang
        })
      );
    }
    this._setupForm();
  }
}
